import React, { useState, useEffect } from "react";
import { Modal, Input, ActionButton } from "../../shared";

export interface BulkSaveConfirmModalProps {
  isOpen: boolean;
  transactionCount: number;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  /** Called after user confirms; verify password and run bulk update in the parent. */
  onConfirm: (password: string) => void | Promise<void>;
}

export const BulkSaveConfirmModal: React.FC<BulkSaveConfirmModalProps> = ({
  isOpen,
  transactionCount,
  loading,
  error,
  onClose,
  onConfirm,
}) => {
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (isOpen) setPassword("");
  }, [isOpen]);

  const handleClose = () => {
    setPassword("");
    onClose();
  };

  const handleConfirm = () => {
    const p = password.trim();
    if (!p || loading) return;
    void onConfirm(p);
  };

  return (
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title="Confirmar atualização em lote"
        size="sm"
        headerGradient="blue"
        stackZClassName="z-[60]"
      >
        <div className="space-y-4">
          <p className="text-sm text-gray-600 dark:text-slate-400">
            Você está prestes a atualizar <strong>{transactionCount}</strong> lançamento(s). Esta ação
            não pode ser desfeita automaticamente. Digite sua senha de acesso para confirmar.
          </p>
          <Input
            label="Senha"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            autoComplete="current-password"
            onKeyDown={(e) => {
              if (e.key === "Enter" && password.trim() && !loading) {
                e.preventDefault();
                handleConfirm();
              }
            }}
          />
          {error && (
            <p className="text-sm text-red-600 dark:text-red-400" role="alert">
              {error}
            </p>
          )}
          <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-2 border-t border-gray-200 dark:border-[#374151]">
            <ActionButton variant="outline" size="sm" onClick={handleClose} disabled={loading}>
              Cancelar
            </ActionButton>
            <ActionButton
              variant="primary"
              size="sm"
              onClick={handleConfirm}
              disabled={loading || !password.trim()}
              loading={loading}
            >
              Confirmar e atualizar
            </ActionButton>
          </div>
        </div>
      </Modal>
  );
};
